import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "vuecmf-editor demo", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("此处可以自定义上传组件或接入外部文件管理器组件，如"), /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/vuecmf/vue-vuecmf-fileexplorer",
  target: "_blank"
}, "vue-vuecmf-fileexplorer")], -1);
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vuecmf_editor = _resolveComponent("vuecmf-editor");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_vuecmf_editor, {
    id: "myeditor",
    size: "default",
    content: _ctx.contentHtml,
    onOnChange: _ctx.getContent,
    token: _ctx.token,
    params: _ctx.params,
    upload: "http://www.vuecmf.com/vuecmf/upload",
    openai: "http://localhost:8080/web/ai",
    upload_action: _ctx.uploadAction,
    amap_key: "高德地图申请的应用KEY"
  }, null, 8, ["content", "onOnChange", "token", "params", "upload_action"]), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.save && _ctx.save(...args))
  }, "保存"), _createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.dialogVisible = $event),
    title: "上传文件",
    width: "50%"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.dialogVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.saveFile
    }, {
      default: _withCtx(() => [_createTextVNode("确定")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["modelValue"])], 64);
}